import { Reducer } from "redux";

import { get404InitialData } from "../utils";
import { RelationshipTypeMasterActionDispatchTypes } from "../constants/Master";
import { RelationshipTypeResponse } from "../models/Api/Master";
import {  RelationshipTypeDispatchTypes } from "../models/DispatchTypes/Patient";

export const initialState: RelationshipTypeResponse = {
  loading: false,
  response: [],
};

const RelationshipTypeMasterReducer: Reducer<
    RelationshipTypeResponse,
    RelationshipTypeDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case RelationshipTypeMasterActionDispatchTypes.RELATIONSHIP_TYPE_MASTER_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case RelationshipTypeMasterActionDispatchTypes.RELATIONSHIP_TYPE_MASTER_SUCCESS: {
      return {
        ...state,
        response: get404InitialData(action.response, []),
        loading: false,
      };
    }
    case RelationshipTypeMasterActionDispatchTypes.RELATIONSHIP_TYPE_MASTER_ERROR: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default RelationshipTypeMasterReducer;
